 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import LOVE_1 from '@/components/love_1'
 import TITLEPAGE from '@/components/titlepage'
 import COPYRIGHT from '@/components/copyright'
 import CONTENTS from '@/components/contents'
 import NEWSLETTERSIGNUP from '@/components/newslettersignup'
 import DEDICATION from '@/components/dedication'
 import CHAPTER001 from '@/components/chapter001'
 import CHAPTER002 from '@/components/chapter002'
 import CHAPTER003 from '@/components/chapter003'
 import CHAPTER004 from '@/components/chapter004'
 import CHAPTER005 from '@/components/chapter005'
 import CHAPTER006 from '@/components/chapter006'
 import CHAPTER007 from '@/components/chapter007'
 import CHAPTER008 from '@/components/chapter008'
 import CHAPTER009 from '@/components/chapter009'
 import CHAPTER010 from '@/components/chapter010'
 import CHAPTER011 from '@/components/chapter011'
 import CHAPTER012 from '@/components/chapter012'
 import CHAPTER013 from '@/components/chapter013'
 import CHAPTER014 from '@/components/chapter014'
 import CHAPTER015 from '@/components/chapter015'
 import CHAPTER016 from '@/components/chapter016'
 import CHAPTER017 from '@/components/chapter017'
 import CHAPTER018 from '@/components/chapter018'
 import CHAPTER019 from '@/components/chapter019'
 import CHAPTER020 from '@/components/chapter020'
 import CHAPTER021 from '@/components/chapter021'
 import CHAPTER022 from '@/components/chapter022'
 import CHAPTER023 from '@/components/chapter023'
 import CHAPTER024 from '@/components/chapter024'
 import CHAPTER025 from '@/components/chapter025'
 import CHAPTER026 from '@/components/chapter026'
 import CHAPTER027 from '@/components/chapter027'
 import CHAPTER028 from '@/components/chapter028'
 import CHAPTER029 from '@/components/chapter029'
 import CHAPTER030 from '@/components/chapter030'
 import CHAPTER031 from '@/components/chapter031'
 import CHAPTER032 from '@/components/chapter032'
 import CHAPTER033 from '@/components/chapter033'
 import CHAPTER034 from '@/components/chapter034'
 import CHAPTER035 from '@/components/chapter035'
 import CHAPTER036 from '@/components/chapter036'
 import CHAPTER037 from '@/components/chapter037'
 import CHAPTER038 from '@/components/chapter038'
 import CHAPTER039 from '@/components/chapter039'
 import CHAPTER040 from '@/components/chapter040'
 import CHAPTER041 from '@/components/chapter041'
 import CHAPTER042 from '@/components/chapter042'
 import CHAPTER043 from '@/components/chapter043'
 import CHAPTER044 from '@/components/chapter044'
 import CHAPTER045 from '@/components/chapter045'
 import LOVE_2 from '@/components/love_2'
 import NEWSLETTERSIGNUP2 from '@/components/newslettersignup2'
 import ALSOBYLUCYMITCHELL from '@/components/alsobylucymitchell'
 import YOUWILLALSOENJOY from '@/components/youwillalsoenjoy'
 import AMESSAGEFROMLUCY from '@/components/amessagefromlucy'
 import ACKNOWLEDGEMENTS from '@/components/acknowledgements'
 import ANOTEFROMTHEPUBLISHER from '@/components/anotefromthepublisher'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/titlepage",
 			"name" : "titlepage",
 			"component" : TITLEPAGE
 		},
 		{
 			"path" : "/copyright",
 			"name" : "copyright",
 			"component" : COPYRIGHT
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/newslettersignup",
 			"name" : "newslettersignup",
 			"component" : NEWSLETTERSIGNUP
 		},
 		{
 			"path" : "/dedication",
 			"name" : "dedication",
 			"component" : DEDICATION
 		},
 		{
 			"path" : "/chapter001",
 			"name" : "chapter001",
 			"component" : CHAPTER001
 		},
 		{
 			"path" : "/chapter002",
 			"name" : "chapter002",
 			"component" : CHAPTER002
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js